function expanding_block(){
    let expandingBlocks = document.querySelectorAll('.expainding-block');
    for (let index = 0; index < expandingBlocks.length; index++) {
        const element = expandingBlocks[index];
        const trig = element.querySelector('.expand-trigger');
        trig.addEventListener('click', function(){
            element.classList.toggle('open');
        });
        
    }

}
   

export default expanding_block;
